import Card from '@/components/Card';
import { DescriptionComponent, MainHeader } from '../styles';
import Typography from '@mui/material/Typography';
import DescriptionPopper from '@/components/DescriptionPopper';
import { EditButton } from '../../General/styles';
import { Pencil } from 'lucide-react';
import { BadgeTitle, BadgeValue, CardBody, InfoBadge } from '../../styles';
import Skeleton from '@mui/material/Skeleton';
import { useTranslation } from 'react-i18next';
import { radio24FieldList } from '@/utils/constants';
import type { Dispatch, SetStateAction } from 'react';

interface RadioCardProps {
  radioFrequency: 'radio24' | 'radio50';
  modeView: string;
  loading: boolean;
  radio: NetworkInterfaceType | undefined;
  setCurrentModal: Dispatch<
    SetStateAction<
      | 'radio24'
      | 'radio50'
      | 'wifi24'
      | 'wifi50'
      | 'apSelect24'
      | 'apSelect50'
      | null
    >
  >;
}

/** Displays Current Equipments Radio Card with info based on radio24FieldList */
function RadioCard({
  radioFrequency,
  modeView,
  loading,
  radio,
  setCurrentModal,
}: RadioCardProps) {
  const { t } = useTranslation();

  return (
    <Card sx={{ maxWidth: '100%' }}>
      <MainHeader>
        <Typography variant="h3">
          {t(`equipment.wifis.${radioFrequency}`)}
        </Typography>
        <div className="divHeader"></div>

        <DescriptionPopper
          description={
            <DescriptionComponent>
              {t(`equipment.radio.${radioFrequency}Edit`)}
            </DescriptionComponent>
          }
          placement="top"
          children={
            <EditButton onClick={() => setCurrentModal(radioFrequency)}>
              <Pencil size={18} />
            </EditButton>
          }
        />
      </MainHeader>
      <CardBody modeView={modeView === 'grid'}>
        {radio24FieldList.map((field: EditorPropType) => (
          <InfoBadge modeView={modeView}>
            <BadgeTitle modeView={modeView}>
              {t(`equipment.radio.${field.field}`)}
            </BadgeTitle>
            {loading ? (
              <Skeleton
                variant="rounded"
                width={modeView === 'grid' ? '225px' : '100%'}
                height={14}
              />
            ) : (
              <BadgeValue modeView={modeView}>
                {radio?.[field.field] != null
                  ? (radio[field.field]?.value ?? 'N/A')
                  : 'N/A'}
              </BadgeValue>
            )}
          </InfoBadge>
        ))}
      </CardBody>
    </Card>
  );
}

export default RadioCard;
